import { Navigate } from "../../../../../router-utils"

export default function OrganizationDocumentPage() {
	return <Navigate to={"/org/document/types"} replace />
}
